import * as classNames from "classnames";
import * as React from "react";
import * as myClasses from "../../../../components";

import { Text } from "@blueprintjs/core";

import { IListSearchBarProps } from "../";

import { ListTree } from "../list-tree/list-tree";

import { IMPDTreeProps } from "src/mpd-library";

import './styles.css';

interface IListSearchProps extends IListSearchBarProps, IMPDTreeProps {
  list: Array<any>;
}

export const ListSearch: React.SFC<IListSearchProps> = props => {
  const {
    className,
    list,
    NodeItem,
    loading,
    onNodeCollapse,
    onNodeExpand,
    onNodeClick,
    searchBarText
  } = props;

  const classes = classNames(myClasses.SEARCH_LIST_CONTAINER, className);

  if (list.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      {list.map((element, index) => (
        <div className={myClasses.SEARCH_LIST_ALERT_CONTAINER} key={index}>
          <div className={myClasses.SEARCH_LIST_ALERT}>
            <Text>
              <span>{element[0].type}</span> alerts with "<span>{searchBarText}</span>
            </Text>
          </div>
          <ListTree
            NodeItem={NodeItem}
            contents={element}
            onNodeCollapse={onNodeCollapse}
            onNodeExpand={onNodeExpand}
            onNodeClick={onNodeClick}
            loading={loading}
          />
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/list-search/list-search.tsx